import React from "react";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import IconButton from "@mui/material/IconButton";

export default function Pagination({
  currentPage,
  totalPages,
  onPageChange,
  maxVisibleDots = 3,
  ...props
}) {
  //calculate visible dots
  let startPage = Math.max(1, currentPage - Math.floor(maxVisibleDots / 2));
  let endPage = startPage + maxVisibleDots - 1;

  if (endPage > totalPages) {
    endPage = totalPages;
    startPage = Math.max(1, endPage - maxVisibleDots + 1);
  }

  //   const visiblePages = Array.from(
  //     { length: endPage - startPage + 1 },
  //     (_, i) => startPage + i
  //   );

  return (
    <div className="assignment-due-pagination-box">
      <IconButton
        aria-label="Previous page"
        disabled={currentPage === 1}
        onClick={() => onPageChange(currentPage - 1)}
      >
        <ArrowBackIosIcon
          className={`assignment-due-pagination-box-arrowback ${
            currentPage === 1 ? "disabled" : ""
          }`}
        />
      </IconButton>

      <div
        className="assignment-due-pagination-box-dots-sec"
        style={{ width: `${maxVisibleDots * 12}px` }}
      >
        <div
          className="pagination-dots-inner"
          style={{
            transform: `translateX(-${(startPage - 1) * 12}px)`,
          }}
        >
          {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
            <button
              key={page}
              className={`assignment-due-pagination-box-dots ${
                currentPage === page ? "selected" : ""
              }`}
              onClick={() => onPageChange(page)}
              aria-label={`Go to page ${page}`}
            >
              •
            </button>
          ))}
        </div>
      </div>

      <IconButton
        aria-label="Next page"
        disabled={currentPage === totalPages}
        onClick={() => onPageChange(currentPage + 1)}
      >
        <ArrowForwardIosIcon
          className={`assignment-due-pagination-box-arrowforward ${
            currentPage === totalPages ? "disabled" : ""
          }`}
        />
      </IconButton>
    </div>
  );
}
